// Shared display helpers for Harmony Candor.

export const VERDICT_STYLE = {
  RED:   { label: 'Red',   cls: 'bg-red-100 text-red-700 border-red-200',       dot: 'bg-red-500' },
  AMBER: { label: 'Amber', cls: 'bg-amber-100 text-amber-800 border-amber-200', dot: 'bg-amber-500' },
  GREEN: { label: 'Green', cls: 'bg-emerald-100 text-emerald-700 border-emerald-200', dot: 'bg-emerald-500' },
};

export const STATE_STYLE = {
  waiting: { label: 'Waiting for candidate', cls: 'bg-slate-100 text-slate-600 border-slate-200' },
  live:    { label: 'Live',                  cls: 'bg-emerald-100 text-emerald-700 border-emerald-200', pulse: true },
  silent:  { label: 'Scanner not reporting', cls: 'bg-red-100 text-red-700 border-red-200' },
  ended:   { label: 'Ended',                 cls: 'bg-slate-100 text-slate-500 border-slate-200' },
  expired: { label: 'Link expired',          cls: 'bg-slate-100 text-slate-500 border-slate-200' },
};

export const SEVERITY_STYLE = {
  high:   { label: 'High',   cls: 'bg-red-100 text-red-700 border-red-200' },
  medium: { label: 'Medium', cls: 'bg-amber-100 text-amber-800 border-amber-200' },
  low:    { label: 'Low',    cls: 'bg-slate-100 text-slate-600 border-slate-200' },
};

// Plain-English names for scanner check ids.
export const CHECK_LABEL = {
  capture_excluded: 'Hidden from screen share',
  overlay_window: 'Overlay window',
  known_tool_process: 'Known cheating tool running',
  known_tool_title: 'Cheating tool in a window title',
  known_tool_installed: 'Cheating tool installed',
  remote_session: 'Remote Desktop session',
  remote_control: 'Remote-control software',
  dns_tool_domain: 'Contacted cheating-tool site',
  dns_llm_api: 'Contacted AI / speech API',
  dns_chat_site: 'Visited AI chat site',
  ai_app_process: 'AI assistant app running',
  multiple_monitors: 'More than one display',
  virtual_machine: 'Running in a virtual machine',
  virtual_audio: 'Virtual audio device',
  virtual_camera: 'Virtual camera',
  foreground: 'App focus change',
};

export const fmtTime = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
};

export const fmtDateTime = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString([], { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
};

export const ago = (iso) => {
  if (!iso) return 'never';
  const s = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};

// The candidate page is a frontend route, so its link must use the origin the
// interviewer is actually on. The backend can't tell: on prod it sits behind
// the Emergent ingress and sees the internal *.emergent.host name, not
// apps.harmonydi.com.
export const candidateLink = (s) => {
  const path = (s?.candidate_link || '').replace(/^https?:\/\/[^/]+/, '');
  return path ? `${window.location.origin}${path}` : '';
};

export const commandFor = (scriptUrl) =>
  `powershell -NoProfile -ExecutionPolicy Bypass -Command "[Net.ServicePointManager]::SecurityProtocol='Tls12'; iex ((New-Object Net.WebClient).DownloadString('${scriptUrl}'))"`;
